import React from 'react';
import { validateAddress } from '@debbie/common/dist';
import { GOOGLE_MAPS_API_KEY } from '../config';
const StreetView = (props) => (React.createElement("div", { style: Object.assign({ height: props.height, overflow: 'hidden', display: 'inline-block', width: props.width || '300px', borderRadius: '3px' }, props.style) }, props.address &&
    (validateAddress(props.address) ? (React.createElement("img", { style: {
            width: props.width || '300px',
            height: props.height,
            marginBottom: '-30px',
        }, src: `https://maps.googleapis.com/maps/api/streetview?location=${`${props.address.address}, ${props.address.zipcode} ${props.address.city}`}&size=${600}x${400}&key=${GOOGLE_MAPS_API_KEY}` })) : null)));
export default StreetView;
//# sourceMappingURL=StreetView.js.map